import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { useParams, useNavigate } from 'react-router-dom';
import TypesMenu from '../../containers/types-menu-container';
import settingsConfig from '../../settings-config';
import MasterData from './master-data';
import Fse from './fse-skills';
import usePermissionCheck from '../../../utils/hooks/usePermissionCheck';

const Skills = ({
  intl,
}) => {
  const params = useParams();
  const navigate = useNavigate();
  const [checkPermission] = usePermissionCheck();
  const isAssigner = checkPermission(settingsConfig.permissions.skillsassigner);
  const isManager = checkPermission(settingsConfig.permissions.skillsmanager);

  const submenu = [
    isAssigner && {
      title: intl.formatMessage({ id: 'skills.FSE_FULL' }),
      type: 'fse',
      url: settingsConfig.skillMenuTypes.fse,
    },
    isManager && {
      title: intl.formatMessage({ id: 'skills.MASTER_DATA' }),
      type: 'master',
      url: settingsConfig.skillMenuTypes.master,
    },
  ].filter(v => v);

  useEffect(() => {
    if (!params.type) {
      const defaultValue = isAssigner ?
        settingsConfig.skillMenuTypes.fse :
        settingsConfig.skillMenuTypes.master;
      navigate(submenu[0]?.url || defaultValue);
    }
  }, [params.type]);

  const renderContent = () => {
    if (params.type === settingsConfig.skillMenuTypes.fse && isAssigner) {
      return <Fse />;
    }
    if (params.type === settingsConfig.skillMenuTypes.master && isManager) {
      return <MasterData />;
    }
    return null;
  };

  return <>
    <TypesMenu
      items={submenu}
    />
    {renderContent()}
  </>;
};

Skills.propTypes = {
  intl: PropTypes.object,
};

export default injectIntl(Skills);
